import { jsx as _jsx } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import AdminRallyPageLayout from '../../../layout/AdminRallyPageLayout';
const CreateRallyPage = () => {
    const { t } = useTranslation();
    return _jsx(AdminRallyPageLayout, { title: `${t('admin.create_new_rally')}.`, formType: 'create' });
};
export default CreateRallyPage;
